import Cookies from "universal-cookie";
import { put } from "axios";

export class ApiResponseError extends Error {
  constructor(response, ...args) {
    super("Api response error", ...args);
    this.name = "ApiResponseError";
    this.body = response.body;
    this.status = response.status;
  }
}
const parseResponse = async (response) => ({
  ok: response.ok,
  status: response.status,
  body: await response.json(),
});

export const getJsonRequest = async ({ url }) => {
  const cookies = new Cookies();
  const headers = new Headers({
    "X-CSRF-TOKEN": cookies.get("XSRF-TOKEN"),
    "Access-Control-Allow-Credentials": true,
  });
  const myInit = {
    method: "GET",
    headers: headers,
    mode: "cors",
    credentials: "include",
    cache: "default",
  };

  const response = await fetch(url, myInit);
  const parsedResponse = await parseResponse(response);
  if (!response.ok) {
    throw new ApiResponseError(parsedResponse);
  }
  return parsedResponse;
};

export const deleteJsonRequest = async ({ url, body }) => {
  const cookies = new Cookies();
  const myHeaders = new Headers({
    "X-CSRF-TOKEN": cookies.get("XSRF-TOKEN"),
    "Content-Type": "application/json",
    "Access-Control-Allow-Credentials": true,
  });
  const myInit = {
    method: "DELETE",
    headers: myHeaders,
    mode: "cors",
    credentials: "include",
    cache: "default",
    body: JSON.stringify(body),
  };
  const response = await fetch(url, myInit);
  if (!response.ok) {
    throw Error();
  }
  return await parseResponse(response);
};

export const patchJsonRequest = async ({ url, body }) => {
  const cookies = new Cookies();
  const myHeaders = new Headers({
    "X-CSRF-TOKEN": cookies.get("XSRF-TOKEN"),
    "Content-Type": "application/json",
    "Access-Control-Allow-Credentials": true,
  });
  const myInit = {
    method: "PATCH",
    headers: myHeaders,
    mode: "cors",
    credentials: "include",
    cache: "default",
    body: JSON.stringify(body),
  };
  const response = await fetch(url, myInit);
  const parsedResponse = await parseResponse(response);
  if (!response.ok) {
    throw new ApiResponseError(parsedResponse);
  }
  return parsedResponse;
};

export const postJsonRequest = async ({ url, body }) => {
  const cookies = new Cookies();
  const myHeaders = new Headers({
    "X-CSRF-TOKEN": cookies.get("XSRF-TOKEN"),
    "Content-Type": "application/json",
    "Access-Control-Allow-Credentials": true,
  });
  const myInit = {
    method: "POST",
    headers: myHeaders,
    mode: "cors",
    cache: "default",
    credentials: "include",
    body: JSON.stringify(body),
  };
  const response = await fetch(url, myInit);
  const parsedResponse = await parseResponse(response);
  if (!response.ok) {
    throw new ApiResponseError(parsedResponse);
  }
  return parsedResponse;
};

export const uploadJsonRequest = async ({ url, body, data }) => {
  const formData = new FormData();
  Object.keys(body).forEach((key) => formData.append(key, body[key]));
  const cookies = new Cookies();
  const myHeaders = new Headers({
    "X-CSRF-TOKEN": cookies.get("XSRF-TOKEN"),
    "Content-Type": "multipart/form-data",
    "Access-Control-Allow-Credentials": true,
  });
  const config = {
    headers: myHeaders,
    mode: "cors",
    credentials: "include",
    cache: "default",
  };
  const response = await put(url, formData, config);
  return { ...response, body: response.data };
};
